<app-driveb-master-wrapper>
  <div class="dialog-header first">
    <h3 translate>dialog-before-manually-add-part-budget.title</h3>
    <button
      class="close-button relative"
      mat-icon-button
      tabindex="-1"
      cdkFocusInitial
      (click)="callCloseDialog()"
      id="message-before-manually-add-part-modal-header-button-close"
    >
      <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
    </button>
  </div>

  <div class="dialog-content">
    <p translate>dialog-before-manually-add-part-budget.subtitle</p>
  </div>

  <div class="dialog-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="callUseExistingPart()"
      style="height: 49px"
      id="message-before-manually-add-part-modal-form-button-use-existing-part"
    >
      {{
        "dialog-before-manually-add-part-budget.text-button-use-existing-part"
          | translate
      }}
    </button>
    <button
      mat-button
      (click)="callCreatePart()"
      style="height: 49px"
      id="message-before-manually-add-part-modal-form-button-create-part"
    >
      {{
        "dialog-before-manually-add-part-budget.text-button-create-part"
          | translate
      }}
    </button>
  </div>
</app-driveb-master-wrapper>
